import { Lightbulb, Scale, Shield } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";
const ContinuedEducation = () => {
  return <section className="py-16 md:py-24 px-6 relative overflow-hidden">
      <div className="absolute top-0 right-1/4 w-64 h-64 bg-primary/10 rounded-full filter blur-[80px]"></div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="flex-1 order-2 md:order-1">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Continued AI Education Services</h2>
            <p className="text-lg text-white/80 mb-6 leading-relaxed">
              Docket Labs' AI education for legal professionals equips them with the skills to effectively think about and adopt and integrate AI tools into daily practice. This includes basic AI fluency, legal industry use cases, and training on practical applications while addressing ethical considerations like bias and confidentiality.
            </p>
            <p className="text-lg text-white/80 mb-6 leading-relaxed">
              Our modular program emphasizes hands-on learning with tools alongside strategies for prompt engineering and risk management. By mastering these competencies, legal professionals can enhance efficiency and innovation, ensuring they remain competitive in an evolving technological landscape.
            </p>
          </div>
          
          <div className="flex-1 order-1 md:order-2">
            <div className="grid grid-cols-1 gap-6">
              <AnimatedCard animation="slide-in-right" delay={0} className="p-5 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-primary/20">
                    <Lightbulb className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">AI Fluency</h3>
                    <p className="text-white/70">Understanding core AI concepts and applications specific to legal practice</p>
                  </div>
                </div>
              </AnimatedCard>
              
              <AnimatedCard animation="slide-in-right" delay={200} className="p-5 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-blue-500/20">
                    <Scale className="h-6 w-6 text-blue-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Practical Applications</h3>
                    <p className="text-white/70">Implementing AI tools for document review, research, and workflow optimization</p>
                  </div>
                </div>
              </AnimatedCard>
              
              <AnimatedCard animation="slide-in-right" delay={400} className="p-5 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-purple-500/20">
                    <Shield className="h-6 w-6 text-purple-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Ethical Considerations</h3>
                    <p className="text-white/70">Addressing bias, confidentiality, and responsible AI usage in legal contexts</p>
                  </div>
                </div>
              </AnimatedCard>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default ContinuedEducation;